import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import {  faXmark, faHouse, faAddressCard, faBriefcase, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

const NavigationZone = () => {

    const [isAnimating, setIsAnimating] = useState(false)
    const [showFixBar, setShowFixBar] = useState(false)
    const [shouldAnimate, setShouldAnimate] = useState(false); // Tracks animation trigger
    const goHomePage = useNavigate()
    const workPage = useNavigate()
    const aboutPage = useNavigate()
    const getInThere = useNavigate()
   
    const showNavigation = () => {
      setShowFixBar(true)
      setIsAnimating(false)
  
    }
    const clickOnX =() => {
      setIsAnimating(true)
       // Add animation class
    }
    const workTime = () => {
      workPage('/workSpace')
      setIsAnimating(true)
  
    }
    const getIn = () => {
getInThere('/getInTouch')
    }
  
    const homePage = () => {
      goHomePage('/')
      setIsAnimating(true)
    
    }
    const aboutMyself = () => {
aboutPage('/aboutMe')
    }
    return (  
        <div className="navigation-zone">
<div className="heading">
<div className="firstSection">
  <div className="logo">
  <h1>L</h1>

  </div>
        <div className="litHeading">
        <h2 className="lit-codes">LIT PORTFOLIO</h2>
<p className="belowIcon"> Taking My Freelancing Career To Another Level.</p>

        </div>


        {/* <FontAwesomeIcon icon={faSun} className="theSun"/> */}
        </div>
       
          
        <div className="navigation" onClick={showNavigation}>
        <FontAwesomeIcon icon={faBars} />
        </div>
        {showFixBar && (

        <div className={`navigationBar ${isAnimating ? "slide-out-right" : ""}`}>
          <div className="xMark">
          <FontAwesomeIcon icon={faXmark} className="xMark" onClick={clickOnX}/>
          </div>
          <p className="sideBar">Sidebar</p>
          <p className="whiteLine"></p>
          <div className="home" onClick={homePage}>
          <FontAwesomeIcon icon={faHouse} className="homeIcon"/>
          <p> Home</p>
          </div>

          <div className="home" onClick={aboutMyself}>
          <FontAwesomeIcon icon={faAddressCard} className="homeIcon"/>
          <p> About</p>
          </div>

          <div className="home" onClick={workTime}>
          <FontAwesomeIcon icon={faBriefcase} className="homeIcon"/>
          <p> Projects</p>
          </div>


          <div className="home" onClick={getIn}>
          <FontAwesomeIcon icon={faFileSignature} className="homeIcon"/>
          <p> Get in touch</p>
          </div>


          {/* <!-- From Uiverse.io by SnyDeTreves -->  */}
          {/* <div className="btn-container">
      <div style={{ "--a": 0 }} className="btn-sensor sensor-n"></div>
      <div style={{ "--a": 45 }} className="btn-sensor sensor-ne"></div>
      <div style={{ "--a": 90 }} className="btn-sensor sensor-e"></div>
      <div style={{ "--a": 135 }} className="btn-sensor sensor-se"></div>
      <div style={{ "--a": 180 }} className="btn-sensor sensor-s"></div>
      <div style={{ "--a": 225 }} className="btn-sensor sensor-sw"></div>
      <div style={{ "--a": 270 }} className="btn-sensor sensor-w"></div>
      <div style={{ "--a": 315 }} className="btn-sensor sensor-nw"></div>
      
      <button className="btn-button">
        <div className="btn-lid"></div>
        <div className="btn-pupil"></div>
      </button>
      <button className="btn-button">
        <div className="btn-lid"></div>
        <div className="btn-pupil"></div>
      </button>
    </div> */}

          
        </div>
    
         )}
        
       
</div>

        </div>
    );
}
 
export default NavigationZone;